module.exports = __webpack_public_path__ + "img/transcript.70b2d205.png";